import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'META_VENDEDOR_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('metaVendedorForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/metaVendedor`);
    return {
        type: 'META_VENDEDOR_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/metaVendedor`, {
				...registro,
				volume: FormatUtils.formatarValorBanco(registro.volume, 2),
				margem: FormatUtils.formatarValorBanco(registro.margem, 2),
				inadimplencia: FormatUtils.formatarValorBanco(registro.inadimplencia, 2),
				prazo: FormatUtils.formatarValorBanco(registro.prazo, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/metaVendedor`, {
				...registro,
				volume: FormatUtils.formatarValorBanco(registro.volume, 2),
				margem: FormatUtils.formatarValorBanco(registro.margem, 2),
				inadimplencia: FormatUtils.formatarValorBanco(registro.inadimplencia, 2),
				prazo: FormatUtils.formatarValorBanco(registro.prazo, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/metaVendedor?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaVendedor() {
    const request = axios.get(`${consts.API_URL}/usuario/listarSelect`);
    return {
        type: 'META_VENDEDOR_VENDEDOR_SELECT_LISTADO',
        payload: request
    };
}

export function getListaResultado() {
    const request = axios.get(`${consts.API_URL}/metaVendedor/resultado`);
    return {
        type: 'META_VENDEDOR_RESULTADO_LISTADO',
        payload: request
    };
}